import { Route, Routes } from "react-router-dom";
import HomeScreen from "../screen/HomeScreen";

const WebsiteNavigation = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeScreen />} />
    </Routes>
  );
};

export default WebsiteNavigation;
